const LIGHT_STYLES = {
  active: "bg-[#d1fae5] text-[#065f46]",
  inactive: "bg-gray-100 text-gray-500",
  pending: "bg-yellow-100 text-yellow-700",
};

const FILLED_STYLES = {
  active: "bg-[#16A149] text-white",
  inactive: "bg-gray-400 text-white",
  pending: "bg-yellow-500 text-white",
};

const StatusBadge = ({ status, filled = false }) => {
  const key = status?.toLowerCase() ?? "";
  const styles = filled ? FILLED_STYLES : LIGHT_STYLES;
  return (
    <span
      className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${
        styles[key] ?? "bg-gray-100 text-gray-500"
      }`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
